<template>
  <main-layout>
    <form-layout>
      <el-form
        v-if="form"
        :model="form"
        :rules="rules"
        label-width="150px"
        ref="form"
      >
        <el-form-item
          :error="errors.name_zh"
          :label="$t('company_name')"
          prop="name"
        >
          <el-input class="el-input--wmd" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item :error="errors.logo" :label="$t('logo')" prop="logo">
          <single-picture-upload
            :action="$store.state.app.configs.uploadServiceUrl + '?cat=temp'"
            :title="$t('size_s')"
            :data="{ category: 'temp' }"
            v-model="form.logo"
          ></single-picture-upload>
        </el-form-item>
        <el-form-item
          :error="errors.yearFounded"
          :label="$t('year_founded')"
          prop="yearFounded"
        >
          <el-date-picker
            :placeholder="$t('pls_select', [])"
            type="year"
            v-model="form.yearFounded"
            value-format="yyyy"
          ></el-date-picker>
        </el-form-item>
        <el-form-item
          :error="errors.website"
          :label="$t('website')"
          prop="website"
        >
          <el-input
            class="el-input--wmd"
            placeholder="http://"
            v-model="form.website"
          ></el-input>
        </el-form-item>
        <el-form-item
          :error="errors.country"
          :label="$t('country')"
          prop="country"
        >
          <el-select
            :placeholder="$t('pls_select', [])"
            filterable
            v-model="form.country"
          >
            <el-option
              :key="item"
              :label="$t(`country_${item}`)"
              :value="item"
              v-for="item in $store.state.app.configs[
                `countries_${$store.getters['app/lang']}`
              ]"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :error="errors.address"
          :label="$t('address')"
          prop="address"
        >
          <el-input
            :rows="3"
            type="textarea"
            v-model="form.address"
            :placeholder="$t('address_placeholder')"
          ></el-input>
        </el-form-item>
        <el-form-item
          :error="errors.size"
          :label="$t('company_size')"
          prop="size"
        >
          <el-radio-group v-model="form.size">
            <el-radio
              :key="item"
              :label="item"
              v-for="item in $store.state.app.configs.companySizes"
              >{{ $t(`company_size_${item}`) }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item :label="$t('company_role')">
          <el-checkbox-group v-model="form.role">
            <el-checkbox
              :key="item"
              :label="item"
              v-for="item in $store.state.app.configs.companyRoles"
            >
              {{ $t(`company_role_${item}`) }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item> -->
        <el-form-item
          :error="errors.listingAttribute"
          :label="$t('listing_attr')"
          prop="listingAttribute"
        >
          <el-radio-group v-model="form.listingAttribute">
            <el-radio
              :key="item"
              :label="item"
              v-for="item in $store.state.app.configs.listingAttributes"
              >{{ $t(`listing_attr_${item}`) }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item
          :error="errors.description"
          :label="$t('company_description')"
          prop="description"
        >
          <el-input
            :rows="3"
            type="textarea"
            v-model="form.description"
          ></el-input>
        </el-form-item>
        <el-form-item
          :error="errors.introduction"
          :label="$t('company_introduction')"
          prop="introduction"
        >
          <el-input
            v-model="form.introduction"
            placeholder="例如： 创新模块化污水处理设备  Innovative modular wastewater treatment system"
          ></el-input>
        </el-form-item>
        <el-form-item
          :error="errors.docs"
          :label="$t('company_introduction_docs')"
          prop="docs"
        >
          <file-upload
            :action="$store.state.app.configs.uploadServiceUrl + '?cat=temp'"
            :data="{ category: 'temp' }"
            :label="$t('browse_to_upload')"
            :limit="10"
            :maxSize="20000"
            :tip="$t('upload_tip', ['20MB', '10', '.pdf, .ppt, .pptx'])"
            accept=".pdf, .ppt, .pptx"
            list-type="text"
            v-model="form.docs"
          ></file-upload>
        </el-form-item>
      </el-form>
      <div slot="bottom-bar">
        <router-link to="/profile">
          <el-button type="primary">
            {{ $t('previous') }}
          </el-button>
        </router-link>
        &nbsp;
        <el-button @click="submit" type="primary">
          {{ $t('next') }}
        </el-button>
      </div>
    </form-layout>
  </main-layout>
</template>

<script>
import { lengthValidator, urlValidator } from '@/utils/validators';
import MainLayout from '@/components/layout/main';
import FormLayout from '@/components/layout/form';
import SinglePictureUpload from '@/components/public/single-picture-upload';
import FileUpload from '@/components/public/file-upload';

export default {
  name: 'Company',
  components: {
    SinglePictureUpload,
    MainLayout,
    FormLayout,
    FileUpload,
  },
  props: {},
  data() {
    return {
      form: null,
      emptyForm: {
        name: '',
        logo: '',
        yearFounded: '',
        website: 'http://',
        country: '',
        address: '',
        size: '',
        role: ['ee'],
        listingAttribute: '',
        description: '',
        introduction: '',
        docs: '',
      },
      errors: {
        name: null,
        logo: null,
        yearFounded: null,
        website: null,
        country: null,
        address: null,
        size: null,
        role: null,
        listingAttribute: null,
        description: null,
        introduction: null,
        docs: null,
      },
      loadingCount: 0,
    };
  },
  computed: {
    rules() {
      return {
        name: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 255,
            trigger: 'blur',
          },
        ],
        logo: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 255,
            trigger: 'change',
          },
        ],
        yearFounded: [
          {
            required: true,
          },
        ],
        website: [
          {
            validator: urlValidator,
            trigger: 'blur',
          },
        ],
        country: [
          {
            required: true,
          },
        ],
        address: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 300,
            trigger: 'change',
          },
        ],
        size: [
          {
            required: true,
          },
        ],
        role: [
          {
            validator: lengthValidator,
            min: 1,
            max: 200,
            trigger: 'change',
          },
        ],
        listingAttribute: [
          {
            required: true,
          },
        ],
        description: [
          {
            validator: lengthValidator,
            min: 1,
            max: 200,
            trigger: 'change',
          },
        ],
        introduction: [
          {
            required: true,
          },
          {
            validator: lengthValidator,
            min: 1,
            max: 50,
            trigger: 'blur',
          },
        ],
        docs: [
          {
            validator: lengthValidator,
            min: 0,
            max: 10,
            trigger: 'blur',
          },
        ],
      };
    },
  },
  watch: {},
  methods: {
    setErrors(errors) {
      if (errors) {
        for (let i = 0; i < errors.length; i++) {
          let error = errors[i];
          if (typeof error === 'string') {
            error = {
              name: error,
              error: ['error'],
            };
          }
          const [text, values] = error.error || [error.message, []];
          this.errors[error.path] = this.$t(text, values || undefined);
        }
      }
    },
    resetErrors() {
      Object.keys(this.errors).forEach(value => {
        if (this.errors[value] instanceof Array) {
          this.errors[value] = this.errors[value].map(() => null);
        } else {
          this.errors[value] = null;
        }
      });
    },
    submit() {
      this.resetErrors();
      this.$refs.form.validate(formValid => {
        if (formValid) {
          this.$store.commit('selfUpload/setCompanyProfile', this.form);
          this.next();
        } else {
          this.$notify.error({
            title: this.$t('operation_failed'),
            message: this.$t('validation_failed'),
          });
        }
        return formValid;
      });
    },
    next() {
      this.$router.push('/business-focus');
    },
  },
  created() {
    const form = Object.assign({}, this.emptyForm);
    if (this.$store.state.selfUpload.companyProfile) {
      Object.assign(form, this.$store.state.selfUpload.companyProfile);
    }
    this.form = form;
  },
};
</script>
